import React from 'react';

import { useIntl } from 'react-intl';
import styled, { useTheme } from 'styled-components';

import IconX from 'components/icons/x';
import UnstyledButton from 'components/unstyled-button';
import { primitive } from 'styles/constants/primitives';

import { DropdownArrow } from './dropdown-arrow';
import { ISize } from './types';

const DropdownContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: ${primitive.$spacing2};

  ${Styles.desktop`
    padding: ${primitive.$spacing3};
  `};
`;

const dropdownArrowSize = {
  mobile: {
    height: 10,
    width: 5.71,
  },
  desktop: {
    height: 14,
    width: 8,
  },
};

const dropdownArrowOrientation = {
  initialAngleDeg: 90,
  finalAngleDeg: -90,
};

export const DropdownIndicator: React.FC<{
  isOpen: boolean;
  isDisabled?: boolean;
}> = ({ isOpen, isDisabled = false }) => (
  <DropdownContainer>
    <DropdownArrow
      open={isOpen || false}
      disabled={isDisabled || false}
      size={dropdownArrowSize}
      orientation={dropdownArrowOrientation}
    />
  </DropdownContainer>
);

const clearSize: ISize = {
  mobile: {
    width: 8,
    height: 8,
  },
  desktop: {
    width: 12,
    height: 12,
  },
};

const ClearButton = styled(UnstyledButton)`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: ${primitive.$spacing2};

  ${Styles.desktop`
    padding: ${primitive.$spacing3};
    padding-right: ${primitive.$spacing2};
  `};
`;

interface IClear {
  size: ISize;
}
const Clear = styled(IconX)<IClear>`
  height: ${p => p.size.mobile.height}px;
  width: ${p => p.size.mobile.width}px;

  ${Styles.desktop`
    height: ${(p: IClear) => p.size.desktop.height}px;
    width: ${(p: IClear) => p.size.desktop.width}px;
  `};
`;

export const ClearIndicator: React.FC<{ isDisabled?: boolean; onClick: () => void }> = ({
  isDisabled = false,
  onClick,
}) => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const fill = isDisabled ? theme.token('icon-disabled') : theme.token('icon-default');
  return (
    <ClearButton aria-label={formatMessage({ id: 'clearFilter' })} onClick={onClick}>
      <Clear fill={fill} size={clearSize} />
    </ClearButton>
  );
};

export const IndicatorSeparator = styled.div`
  display: flex;
  width: 1px;
  align-self: stretch;
  margin: ${primitive.$spacing1} 0;
  background-color: ${p => p.theme.token('border-color-default')};
`;
